// =============================================================
// TitanSox — Password Page Countdown Timer
// =============================================================
// TODO: Set the launch date below before going live.
// Format: 'YYYY-MM-DDTHH:MM:SS' in store local time (AEST = UTC+10)
// =============================================================

(function () {
  // LAUNCH DATE — update this before going live
  // Preferred: set via Shopify Admin → Themes → Customise → Password Page → Launch date
  // Fallback: hardcode here e.g. '2025-08-01T09:00:00+10:00'
  var LAUNCH_DATE = (typeof window.titanLaunchDate !== 'undefined' && window.titanLaunchDate)
    ? window.titanLaunchDate
    : null;

  // If no date is set, default to 14 days from now
  var target = LAUNCH_DATE
    ? new Date(LAUNCH_DATE)
    : new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);

  var daysEl    = document.getElementById('cd-days');
  var hoursEl   = document.getElementById('cd-hours');
  var minsEl    = document.getElementById('cd-mins');
  var secsEl    = document.getElementById('cd-secs');
  var wrapEl    = document.getElementById('countdown-wrap');
  var liveEl    = document.getElementById('countdown-live');

  if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function tick() {
    var diff = target - Date.now();

    if (diff <= 0) {
      // Countdown expired — show live message
      if (wrapEl) wrapEl.style.display = 'none';
      if (liveEl) liveEl.style.display = 'block';
      clearInterval(timer);
      return;
    }

    var totalSecs = Math.floor(diff / 1000);
    var days  = Math.floor(totalSecs / 86400);
    var hours = Math.floor((totalSecs % 86400) / 3600);
    var mins  = Math.floor((totalSecs % 3600) / 60);
    var secs  = totalSecs % 60;

    daysEl.textContent  = pad(days);
    hoursEl.textContent = pad(hours);
    minsEl.textContent  = pad(mins);
    secsEl.textContent  = pad(secs);
  }

  tick();
  var timer = setInterval(tick, 1000);
})();
